import React from 'react';
import {
  Container,
  CircularProgress,
  Box,
  styled,
} from '@material-ui/core';

const ProgressLoader = styled(Box)({
  width: '100%',
  justifyContent: 'center',
  display: 'flex',
  paddingTop: 32,
});

const Loader = () => (
  <Container maxWidth="sm" style={{ marginTop: 32 }}>
    <ProgressLoader>
      <CircularProgress size="6rem" thickness={3} />
    </ProgressLoader>
  </Container>
);

export default Loader;
